import { clearAuthHeaders } from "@/api/service"

export const clearAuthData = () => {
  clearAuthHeaders()
  localStorage.removeItem("tgUserId")
  localStorage.removeItem("userId")
  localStorage.removeItem("last-update-read")
}
